import { parseUA } from './parse_ua';
function hasProperty(prop, object) {
    return object && object.hasOwnProperty(prop);
}
/**
 * Interpolates the provided string with data from the user agent.
 *
 * @param template - The template to interpolate.
 * @return The interpolated string.
 */
export function interpolateUA(template) {
    if (!template) {
        return template;
    }
    const navigatorInfo = parseUA(navigator.userAgent, navigator.platform);
    return template.replace(/\{\{([^}]+?)\}\}/g, function (_match, key) {
        if (hasProperty(key, navigatorInfo)) {
            return navigatorInfo[key];
        }
        return '';
    });
}
//# sourceMappingURL=interpolate_ua.js.map